import React from 'react'

const DotsIcon = () => {
  return (
    <svg width="26" height="5" viewBox="0 0 26 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.5" cy="2.5" r="2.5" fill="#4B5563"/>
        <circle cx="9.5" cy="2.5" r="2.5" fill="#4B5563"/>
        <circle cx="16.5" cy="2.5" r="2.5" fill="#4B5563"/>
        <circle cx="23.5" cy="2.5" r="2.5" fill="#4B5563"/>
    </svg>

  )
}

export default DotsIcon